import { useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { UserPolicies } from '../../models/user-policy';
import { UserRole } from '../../models/UserRole';
import { cn } from '../../utils/cn';
import { ROUTES } from '../../constants/contstants';
import navStyles from './NavBar.module.css';

const NavBar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const { isAuthenticated, logout, userRoles } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isExamTaker = userRoles.includes(UserRole.EXAM_TAKER);
  const canAccessBackoffice = UserPolicies.hasContributorAccess(userRoles) ||
    UserPolicies.hasAnalystAccess(userRoles);
  const isBackofficeRoute = location.pathname.startsWith(ROUTES.ADMIN);

  const handleLogout = () => {
    closeMobileMenu();
    logout();
    navigate('/');
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={navStyles.navbar}>
      <h1 className={navStyles.logo}>
        <NavLink to="/" className={navStyles.logoLink} aria-label="247Labs Academy home">
          <img
            src="/assets/branding/betpikr-logo.png"
            alt="BetPikr"
            className={navStyles.logoImage}
          />
        </NavLink>
      </h1>
      
      {/* Hamburger menu button - only visible on mobile */}
      <button 
        className={navStyles.hamburgerButton}
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      >
        <span className={cn(navStyles.hamburgerLine, isMobileMenuOpen && navStyles['hamburgerLine--open'])}></span>
        <span className={cn(navStyles.hamburgerLine, isMobileMenuOpen && navStyles['hamburgerLine--open'])}></span>
        <span className={cn(navStyles.hamburgerLine, isMobileMenuOpen && navStyles['hamburgerLine--open'])}></span>
      </button>

      <ul className={cn(navStyles.navLinks, isMobileMenuOpen && navStyles['navLinks--open'])}>
        {isAuthenticated && isExamTaker && (
          <li>
            <NavLink
              to={ROUTES.MY_ASSIGNMENTS}
              className={({ isActive }) => cn(
                navStyles.navBtn,
                isActive && navStyles['navBtn--active']
              )}
              onClick={closeMobileMenu}
            >
              My assignments
            </NavLink>
          </li>
        )}
        {isAuthenticated && canAccessBackoffice && (
          <li>
            <NavLink 
              to={ROUTES.ADMIN}
              className={({ isActive }) => cn(
                navStyles.navBtn,
                isActive && navStyles['navBtn--active']
              )}
              onClick={closeMobileMenu}
            >
              Academy backoffice
            </NavLink>
          </li>
        )}
        {isAuthenticated && (
          <>
            <li>
              <button 
                className={navStyles.navBtn}
                onClick={handleLogout}
              >
                Logout
              </button>
            </li>
          </>
        )}
        {!isAuthenticated && !isBackofficeRoute && (
          <>
            <li>
              <NavLink 
                to={ROUTES.ONBOARDING}
                className={({ isActive }) => cn(
                  navStyles.navBtn,
                  isActive && navStyles['navBtn--active']
                )}
                onClick={closeMobileMenu}
              >
                Enter invite code
              </NavLink>
            </li>
            <li>
              <NavLink
                to={ROUTES.LOGIN}
                className={({ isActive }) => cn(
                  navStyles.navBtn,
                  isActive && navStyles['navBtn--active']
                )}
                onClick={closeMobileMenu}
              >
                Sign in
              </NavLink>
            </li>
          </>
        )}
      </ul>
    </nav>
  );
};

export default NavBar;
